<template>
    <BaseCard padding="md" class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div class="flex items-start gap-3 min-w-0 flex-1">
            <ReflectionIcon :kind="kind" size="md" class="mt-1 shrink-0" />
            <div class="flex flex-col gap-1 min-w-0">
                <div class="body-semibold text-ink">{{ title }}</div>
                <p class="scaffold-body-small text-ink-muted"><slot /></p>
            </div>
        </div>
        <a
            v-if="href"
            :href="href"
            class="base-btn-neutral base-btn-sm sm:shrink-0 whitespace-nowrap text-center self-start sm:self-auto"
            :aria-label="t('reflections.shared.actionLabel', { action: t('reflections.sixty.launch'), target: title })"
            @click.prevent="emit('launch')">
            {{ t("reflections.sixty.launch") }}
        </a>
    </BaseCard>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";
import ReflectionIcon, { type ReflectionIconKind } from "~vue/pages/reflections/ReflectionIcon.vue";
import { useI18n } from "vue-i18n";

interface Props {
    kind: ReflectionIconKind;
    title: string;
    // Rows without a destination (team review) render as copy only, since
    // giving feedback depends on a teammate asking first.
    href?: string;
}

defineProps<Props>();
const { t } = useI18n();
const emit = defineEmits<{ (event: "launch"): void }>();
</script>
